export function getConfig() {
  return {
    "backend-url": "https://api.genomicscore.be",
    "services-url": "https://services.genomicscore.be",
  };
}
